/**
 * Created by tayloremolo on 12/5/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class Sponsors extends Component {

    render() {

        return (
            <div>
                <div className="white z-22">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-52 black-text bold-text text-uppercase mb0">Thank You To Our<br/><span className="f-84 ls-5 brand-text">Sponsors</span></h1>
                            </div>
                            <div className="col s8 offset-s2 m4 center-align">
                                <br />
                                <img className="responsive-img p-20" src="../static/twilio-logo.png" alt="Twilio"/>
                            </div>
                            <div className="col s8 offset-s2 m4 center-align">
                                <br className="hide-on-small-and-down"/><br className="hide-on-small-and-down"/>
                                <img className="responsive-img p-20" src="../static/et.png" alt="Eric Thomas"/>
                            </div>
                            <div className="col s8 offset-s2 m4 center-align">
                                <br className="hide-on-small-and-down"/>
                                <img className="responsive-img p-20" src="../static/urby.jpg" alt="Urby"/>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s8 offset-s2 m5 offset-m1 center-align">
                                <img className="responsive-img p-20" src="../static/trinet.png" alt="Trinet"/>
                            </div>
                            <div className="col s8 offset-s2 m5 center-align">
                                {/*<br className="hide-on-small-and-down"/>*/}
                                <img className="responsi" src="../static/platinum.jpg" alt="Platinum" height={170}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default Sponsors;


// WEBPACK FOOTER //
// ./src/components/sponsors.js